import * as Sebrae from '@sebrae/react-core';
import React, { createContext, useContext } from 'react';

import { useModule } from '../../../hooks/module/module';
import { ENDPOINT_INTERVIEWS_MODULE } from '../../../hooks/services/constants';

export const TableInterviewContext = createContext();

export const TableInterviewProvider = ({ children }) => {
  const { moduleSelected } = useModule();
  let a = 10;
  const { fetchData, data, loading, error } = Sebrae.usePagination(
    `${ENDPOINT_INTERVIEWS_MODULE}/${moduleSelected?.id}`,
  );
  const handleFetchInterviewData = React.useCallback(() => {
    fetchData({
      filter: {},
      sort: { type: 'DESC' },
    });
  }, [fetchData]);
  return (
    <TableInterviewContext.Provider
      value={{ fetchData, data, loading, error, a, handleFetchInterviewData }}
    >
      {children}
    </TableInterviewContext.Provider>
  );
};

export const useTableInterview = () => {
  const context = useContext(TableInterviewContext);
  if (!context) {
    throw new Error(
      'useTableCandidate deve ser usado dentro de um TableCandidateProvider',
    );
  }
  return context;
};
